import React from 'react';
import styles from './ResendEmailConfirmationForm.module.css';

import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';

interface Props {
  email: string;
}

export const ResendEmailConfirmationForm: React.FC<Props> = ({ email }) => (
  <>
    <Title>
      Перейдите по ссылке <br /> из письма
    </Title>
    <Description className={styles.description}>
      На вашу почту <span className={styles.email}>{email}</span> отправлено
      письмо с подтверждением.
    </Description>
    <Description>
      Если вы его не получили,
      <br />
      проверьте папку «Спам»
    </Description>
    <Content>
      <EmailButton email={email} />
    </Content>
  </>
);
